import { Box, FileSelector, SpacerNew } from '@jfs/ui-new'
import { Button, ButtonNew } from '../../components/AdminButton'
import { isEmpty, isEmptyObject } from '@jfs/utils'
import * as React from 'react'
import { useEffect, useState } from 'react'
import XlsxPopulate from 'xlsx-populate'
import { Toast, ToastPosition, ToastType } from '../../components/Toast'
import { useLazyApiData, useStores } from '../../data/store'

const SapOnboarding = () => {
  const [filename, setFileName] = useState('')
  const [message, setMessage] = useState('')
  const [wsdata, setWsData] = useState<XlsxPopulate.Workbook>()
  const [fileData, setFileData] = React.useState<any>([])
  const [inputKeys, setInputkeys] = useState<String[]>([])

  const { sapUpload, sapLogin, sampleFileDownload } = useStores((store) => ({
    sapUpload: store.merchantMapping.sapUpload,
    sapLogin: store.merchantMapping.sapLoginApi,
    sampleFileDownload: store.sampleFileDownload,
  }))
  const [sapUploadApi, { state: uploadState, data: uploadData }] = useLazyApiData(sapUpload)
  const [sapLoginApi, { state: loginState, data: loginData }] = useLazyApiData(sapLogin)

  useEffect(() => {
    if (loginState === 'fulfilled') {
      sapUploadApi(loginData, fileData, filename)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginState])
  useEffect(() => {
    if (uploadState === 'fulfilled') {
      writeToFile(uploadData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadState])

  const writeToFile = (outputs: any) => {
    if (outputs?.length > 0 && filename?.length > 0) {
      let transformedData: any = []
      fileData?.forEach((item: any) => {
        inputKeys?.forEach((key) => {
          if (item[key as keyof typeof item] === undefined) {
            item[key as keyof typeof item] = ''
          }
        })
      })
      transformedData = outputs.map((item: any) => [item.status, item.message, item.response])
      transformedData.splice(0, 0, ['Result', 'Message', 'Response'])
      XlsxPopulate.fromBlankAsync().then(async (workbook) => {
        const data: any = []
        data.push([...inputKeys, ...transformedData[0]])
        fileData.map((item: any, index: number) => {
          data.push([...Object.values(item), ...transformedData[index + 1]])
        })

        workbook.sheet(0)?.cell('A1').value(data)

        const blob = await workbook.outputAsync({
          type: 'blob',
        })
        var url = window.URL.createObjectURL(blob as Blob)
        var a = document.createElement('a')
        document.body.appendChild(a)
        a.href = url
        a.download = `createCustomerResult_${filename}.xlsx`
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
      })
    }
  }

  const isValidEntry = (obj: any) => {
    return !isEmptyObject(obj)
  }
  const readFile = async (file: any, name: string) => {
    if (!file) {
      return
    }
    const readPromise = new Promise((resolve, reject) => {
      XlsxPopulate.fromDataAsync(file)
        .then(function (workbook) {
          setFileName(name)
          setWsData(workbook)
          const sheet = workbook.sheet(0)
          const rows = sheet._rows
          const keys: string[] = []
          const values: any = []

          rows.forEach((row: any, rowIndex: number) => {
            const obj: any = {}

            for (let i = 1; i < row._cells.length; i++) {
              if (rowIndex === 1) {
                !isEmpty(row._cells[i]?.value()) && keys.push(`${row._cells[i]?.value() ?? ''}`)
              } else {
                const key = keys[i - 1]
                if (!isEmpty(key)) {
                  obj[key] = `${String(row._cells[i]?.value() ?? '')?.trim()}`
                }
              }
            }
            isValidEntry(obj) && values.push(obj)
          })
          setFileData(values)
          setInputkeys(keys)
          resolve(values)
        })
        .catch((e) => {
          console.log({ e })
          reject('Invalid File')
        })
    })
    try {
      await readPromise
    } catch (e) {
      setWsData(undefined)
      setFileName('')
      setMessage(e.toString())
    }
  }

  return (
    <Box p={16} justify={'center'} align={'center'} h={'100vh'}>
      <FileSelector
        onFileSelect={readFile}
        fileType={'.xlsx'}
        innerCompTitle={'Drop your File here'}
        innnerCompSubtitle={'Browse your file'}
        filename={filename}
      />
      <SpacerNew size={32} />
      <ButtonNew
        title={'Sample file'}
        type="tertiary"
        onPress={() => {
          sampleFileDownload('Sample_sap_upload_file')
        }}
      />
      <SpacerNew direction="vertical" size={16} />
      <Button
        title={'Insert'}
        onPress={() => sapLoginApi()}
        isLoading={loginState === 'pending' || uploadState === 'pending'}
        disabled={!wsdata || fileData.length === 0}
      />
      <Toast
        hide={message?.length === 0}
        type={ToastType.NEGATIVE}
        position={ToastPosition.BOTTOM}
        onDismiss={() => setMessage('')}
        message={message}
      />
    </Box>
  )
}

export default SapOnboarding
